import Ext from 'Ext'
import LeaveRatesEditorItem from './LeaveRatesEditorItem'

const LeaveRatesMenu = function(config)
{
    LeaveRatesMenu.superclass.constructor.call(this, config);
    this.plain = true;
    this.item = new LeaveRatesEditorItem(config);
    this.add(this.item);
    this.canceled = false;
    const self = this;
    this.item.component.on( "cancelclick", function() { self.canceled = true; self.hide(); } );
    this.item.component.on( "okclick", function() { self.canceled = false; self.hide(); } );
}

Ext.extend(LeaveRatesMenu, Ext.menu.Menu, {

    cls:'userDataLightBox_leaveRatesMenu',
    shadow: false,

    setActivatedButton: function( activatedButton )
    {
        this.activatedButton = activatedButton;
    },

    getActivatedButton: function()
    {
        return this.activatedButton;
    },

    setUp: function(leaveRatesArray, defaultValue, isEmptyValid)
    {
        this.item.component.setUp(leaveRatesArray, defaultValue, isEmptyValid);
    },

    getLeaveRates: function()
    {
        return this.item.component.getLeaveRates();
    },

    show : function(el, pos, parentMenu)
    {
        this.parentMenu = parentMenu;
        if(!this.el){
            this.render();
        }
        this.fireEvent("beforeshow", this);
        this.fireEvent("show", this);
        this.el.setXY([-1000,-1000]);
        this.el.show();
        this.hidden = false;
        this.focus();

        // delay position correction since the menu width is changed before show.
        const self = this;
        setTimeout( function() {
            let xy = self.el.getAlignToXY( el, pos || self.defaultAlign, self.offsetXY );
            xy = self.el.adjustForConstraints(xy);
            self.el.setXY( xy );
        }, 5 );

        this.canceled = false;
    },

    wasCanceled: function()
    {
        return this.canceled;
    }
})

export default LeaveRatesMenu


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/ratesEditor/LeaveRatesMenu.js